<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
>
  <!-- <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div> -->
  <div fxFlex="30%">{{ lookup?.optionName }}</div>
  <div fxFlex="grow">{{ lookup?.optionDescription }}</div>
  <div fxFlex="10%" class="text-right">
    <button
      *isPermitted="{ id: 'LOOKUP_DATA_MANAGEMENT', action: 'edit' }"
      class="ui circular tiny button"
      (click)="onEdit.emit(lookup)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Edit"
    >
      <i class="pencil icon"></i>
    </button>
    <button
      *isPermitted="{ id: 'LOOKUP_DATA_MANAGEMENT', action: 'remove' }"
      class="ui circular tiny button"
      (click)="onDelete.emit(lookup)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Delete"
    >
      <i class="trash icon"></i>
    </button>
  </div>
</div>
